import { categories, contentItems } from "@/mocks/portal";
import ContentCard from "@/pages/home/components/ContentCard";

interface CategorySectionProps {
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}

export default function CategorySection({ activeCategory, onCategoryChange }: CategorySectionProps) {
  const list =
    activeCategory === "全部" ? contentItems : contentItems.filter((item) => item.category === activeCategory);

  return (
    <section id="category" className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 md:gap-6">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs md:text-sm font-medium text-primary-600">
              <i className="ri-layout-grid-line"></i>
              分类浏览
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              按主题挑，挑到就直接看
            </h2>
          </div>
          <p className="text-sm md:text-base text-foreground-600 max-w-md leading-relaxed">
            切换下方标签即可筛选对应分区的内容，当前共 <strong className="text-foreground-900">{list.length}</strong> 条。
          </p>
        </div>

        <div className="mt-7 flex flex-wrap gap-2">
          {categories.map((category) => {
            const active = category === activeCategory;
            return (
              <button
                key={category}
                type="button"
                onClick={() => onCategoryChange(category)}
                aria-pressed={active}
                className={`rounded-full px-4 py-2 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors border ${
                  active
                    ? "bg-primary-500 border-primary-500 text-background-50"
                    : "bg-background-50 border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
                }`}
              >
                {category}
              </button>
            );
          })}
        </div>

        {list.length > 0 ? (
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {list.map((item) => (
              <ContentCard key={item.id} item={item} onCategorySelect={onCategoryChange} />
            ))}
          </div>
        ) : (
          <div className="mt-8 rounded-card border border-dashed border-background-300 bg-background-50 py-16 text-center">
            <i className="ri-inbox-archive-line text-4xl text-foreground-400"></i>
            <p className="mt-3 text-sm text-foreground-600">该分区暂无内容，试试切换其他标签。</p>
          </div>
        )}
      </div>
    </section>
  );
}